import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MdEditor from "md-editor-v3";
import "md-editor-v3/lib/style.css";


export default /*#__PURE__*/_defineComponent({
  props: {
  text: String
},
  setup(__props) {

const props = __props



// end

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MdEditor), {
    modelValue: __props.text,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(text) ? (text).value = $event : null)),
    previewOnly: true
  }, null, 8, ["modelValue"]))
}
}

})